<template>
  <div class="dice-dynamic">
    <span class="dice-dynamic__line"></span>
    <span
      class="dice-dynamic__dice"
      :style="movmentString"
      ref="dice"
      :class="'dice-dynamic__dice--show-' + value"
    >
      <span class="dice-dynamic__dice-side dice-dynamic__dice-side--1">
        <span class="dice-dynamic__dice-side-dot" v-for="(i, k) in 1" :key="k"></span>
      </span>
      <span class="dice-dynamic__dice-side dice-dynamic__dice-side--2">
        <span class="dice-dynamic__dice-side-dot" v-for="(i, k) in 2" :key="k"></span>
      </span>
      <span class="dice-dynamic__dice-side dice-dynamic__dice-side--3">
        <span class="dice-dynamic__dice-side-dot" v-for="(i, k) in 3" :key="k"></span>
      </span>
      <span class="dice-dynamic__dice-side dice-dynamic__dice-side--4">
        <span class="dice-dynamic__dice-side-dot" v-for="(i, k) in 4" :key="k"></span>
      </span>
      <span class="dice-dynamic__dice-side dice-dynamic__dice-side--5">
        <span class="dice-dynamic__dice-side-dot" v-for="(i, k) in 5" :key="k"></span>
      </span>
      <span class="dice-dynamic__dice-side dice-dynamic__dice-side--6">
        <span class="dice-dynamic__dice-side-dot" v-for="(i, k) in 6" :key="k"></span>
      </span>
    </span>
  </div>
</template>
<script>
import interact from 'interactjs';

export default {
  name: 'DiscDynamic',
  data() {
    return {
      interactPosition: -1,
    };
  },
  methods: {
    interactSetPosition(pos) {
      const max = this.$refs['dice'].parentNode.clientWidth - this.$refs['dice'].clientWidth;
      const min = this.$refs['dice'].clientWidth * -1.2;
      this.interactPosition = pos < min ? min : pos > max ? max : pos;
    },
  },
  computed: {
    movmentString() {
      return 'margin-left: ' + this.interactPosition + 'px';
    },
    value() {
      if (this.interactPosition < 0) return 0;
      const max = this.$refs['dice'].parentNode.clientWidth - this.$refs['dice'].clientWidth;
      return Math.ceil((this.interactPosition / max) * 6);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.interactPosition = this.$refs['dice'].clientWidth * -1.2;
      interact(this.$refs['dice']).draggable({
        onmove: event => {
          this.interactSetPosition(this.interactPosition + event.dx);
        },
      });
    });
  },
  watch: {
    value() {
      this.$emit('input', this.value);
    },
  },
};
</script>
<style lang="scss">
@import '../styles/settings';
.dice-dynamic {
  $dice: 3rem;
  height: $dice;
  position: relative;
  display: flex;
  &__line {
    position: absolute;
    top: calc(50% - 0.125rem);
    left: 0;
    right: 0;
    border-top: 0.25rem solid #ddd;
    transform-style: preserve-3d;
    z-index: 0;
    transform: rotate3d(1, 1, 1, 0deg)  translateZ(0);
  }
  &__dice {
    width: $dice;
    height: $dice;
    position: absolute;
    left: 0;
    top: calc(50% - #{$dice / 2});
    cursor: pointer;
    z-index: 999999;
    touch-action: none;
    transform: rotate3d(1, 1, 1, 45deg);
    transform:rotateY(0deg);
    transform-style: preserve-3d;
    transition: transform 0.3s ease-in-out;
    &--show-0 #{&}-side:nth-child(1) {
      &:after {
        opacity: 1;
      }
      > * {
        opacity: 0;
      }
    }
    &--show-1 {
      transform:rotateY(0deg);
    }
    &--show-2 {
      transform:rotateX(-90deg) rotateY(-180deg);
    }
    &--show-3 {
      transform:rotateX(-180deg) rotateY(-90deg);
    }
    &--show-4 {
      transform:rotateX(-270deg) rotateY(-180deg);
    }
    &--show-5 {
      transform:rotateX(-180deg) rotateY(0deg);
    }
    &--show-6 {
      transform: rotateX(-270deg) rotateZ(90deg) rotateY(0deg);
    }
    &-side {
      position: absolute;
      left: 0;
      top: 0;
      height: $dice;
      width: $dice;
      text-align: center;
      line-height: $dice;
      background: get-color(dice-user);
      z-index: 9;
      border-radius: 0.25rem;
      &:nth-child(1) {
        transform: translateZ(#{$dice / 2});
        &:after {
          content: '';
          background: get-color(dice-user);
          @include position-corner(0.25rem);
          background-size: 70%;
          position: absolute;
          background-repeat: no-repeat;
          background-position: center;
          opacity: 0;
          transition: opacity 0.3s ease-in-out;
          background-image: url("data:image/svg+xml,%3Csvg xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:cc='http://creativecommons.org/ns%23' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns:svg='http://www.w3.org/2000/svg' xmlns='http://www.w3.org/2000/svg' xmlns:sodipodi='http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd' xmlns:inkscape='http://www.inkscape.org/namespaces/inkscape' version='1.1' x='0px' y='0px' viewBox='0 0 100 100'%3E%3Cg transform='translate(0,-952.36218)'%3E%3Cpath style='font-size:medium;font-style:normal;font-variant:normal;font-weight:normal;font-stretch:normal;text-indent:0;text-align:start;text-decoration:none;line-height:normal;letter-spacing:normal;word-spacing:normal;text-transform:none;direction:ltr;block-progression:tb;writing-mode:lr-tb;text-anchor:start;baseline-shift:baseline;opacity:1;color:%23000000;fill:%23fff;fill-opacity:1;stroke:none;stroke-width:4;marker:none;visibility:visible;display:inline;overflow:visible;enable-background:accumulate;font-family:Sans;-inkscape-font-specification:Sans' d='m 36,6 c -4.397406,0 -8,3.60259 -8,8 l 0,30.40625 C 23.482976,45.36619 20,49.2052 20,54 l 0,8 c 0,4.9917 2.764508,9.9589 6,14.4375 3.023051,4.1845 6.486835,7.80905 9,10.34375 L 35,92 c 1.05e-4,1.047169 0.952831,1.999895 2,2 l 34,0 c 1.047169,-1.05e-4 1.999895,-0.952831 2,-2 L 73,81.6875 C 77.318715,77.0445 80,70.8467 80,64 l 0,-13 c 0,-4.39741 -3.602594,-8 -8,-8 -1.540941,0 -2.900074,0.54856 -4.125,1.3125 C 67.509716,40.24643 64.156394,37 60,37 58.459059,37 57.099926,37.54856 55.875,38.3125 55.509716,34.24643 52.156394,31 48,31 c -1.485348,0 -2.804226,0.50489 -4,1.21875 L 44,14 C 44,9.60259 40.397406,6 36,6 z m 0,4 c 2.250594,0 4,1.74941 4,4 l 0,25 c 0,1.104569 0.895431,2 2,2 1.104569,0 2,-0.895431 2,-2 0,-2.25059 1.749406,-4 4,-4 2.250594,0 4,1.74941 4,4 l 0,6 c 0,1.104569 0.895431,2 2,2 1.104569,0 2,-0.895431 2,-2 0,-2.25059 1.749406,-4 4,-4 2.250594,0 4,1.74941 4,4 l 0,6 c 0,1.104569 0.895431,2 2,2 1.104569,0 2,-0.895431 2,-2 0,-2.2506 1.749406,-4 4,-4 2.250594,0 4,1.7494 4,4 l 0,13 C 76,70.1141 73.567493,75.5888 69.59375,79.5625 69.215129,79.936893 68.995947,80.467545 69,81 l 0,9 -30,0 0,-4 c 0.0041,-0.532455 -0.215129,-1.063107 -0.59375,-1.4375 C 35.934765,82.091 32.264508,78.26635 29.25,74.09375 26.235492,69.92105 24,65.4034 24,62 l 0,-8 c 0,-2.655232 1.648974,-4.848321 4,-5.65625 L 28,60 c -0.01494,1.056625 0.943269,2.028484 2,2.028484 1.056731,0 2.014943,-0.971859 2,-2.028484 l 0,-46 c 0,-2.25059 1.749406,-4 4,-4 z' transform='translate(0,952.36218)'/%3E%3C/g%3E%3C/svg%3E");
        }
      }
      &:nth-child(2) {
        transform: rotateX(90deg) rotate(-180deg) translateZ(#{$dice / 2});
      }
      &:nth-child(3) {
        transform: rotateY(-90deg) rotate(-180deg) translateZ(#{$dice / 2});
      }
      &:nth-child(4) {
        transform: rotateX(-90deg) rotate(-180deg) translateZ(#{$dice / 2});
      }
      &:nth-child(5) {
        transform: rotateY(180deg) rotate(-180deg) translateZ(#{$dice / 2});
      }
      &:nth-child(6) {
        transform: rotateY(90deg) rotate(-90deg) translateZ(#{$dice / 2});
      }
      &-dot {
        width: 0.5rem;
        height: 0.5rem;
        border-radius: 50%;
        background: get-color(white);
        position: absolute;
        transform: translate(-50%, -50%);
      }
      &--1 #{&}-dot {
        &:nth-child(1) {
          left: 50%;
          top: 50%;
          transition: opacity 0.3s ease-in-out;
        }
      }
      &--2 #{&}-dot {
        &:nth-child(1) {
          left: 70%;
          top: 30%;
        }
        &:nth-child(2) {
          left: 30%;
          top: 70%;
        }
      }
      &--3 #{&}-dot {
        &:nth-child(1) {
          left: 70%;
          top: 70%;
        }
        &:nth-child(2) {
          left: 50%;
          top: 50%;
        }
        &:nth-child(3) {
          left: 30%;
          top: 30%;
        }
      }
      &--4 #{&}-dot {
        &:nth-child(1) {
          left: 30%;
          top: 30%;
        }
        &:nth-child(2) {
          left: 70%;
          top: 30%;
        }
        &:nth-child(3) {
          left: 30%;
          top: 70%;
        }
        &:nth-child(4) {
          left: 70%;
          top: 70%;
        }
      }
      &--5 #{&}-dot {
        &:nth-child(1) {
          left: 30%;
          top: 30%;
        }
        &:nth-child(2) {
          left: 70%;
          top: 30%;
        }
        &:nth-child(3) {
          left: 30%;
          top: 70%;
        }
        &:nth-child(4) {
          left: 70%;
          top: 70%;
        }
        &:nth-child(5) {
          left: 50%;
          top: 50%;
        }
      }
      &--6 #{&}-dot {
        &:nth-child(1) {
          left: 30%;
          top: 25%;
        }
        &:nth-child(2) {
          left: 30%;
          top: 50%;
        }
        &:nth-child(3) {
          left: 30%;
          top: 75%;
        }
        &:nth-child(4) {
          left: 70%;
          top: 25%;
        }
        &:nth-child(5) {
          left: 70%;
          top: 50%;
        }
        &:nth-child(6) {
          left: 70%;
          top: 75%;
        }
      }
    }
  }
}
</style>